module.exports = __webpack_public_path__ + "files/bf61680806a56e50a7857eeeea863f01.png";


//////////////////
// WEBPACK FOOTER
// ./images/gitlabLogo.png
// module id = 1362
// module chunks = 59